import React, { useState } from "react";
import axios from "axios";
import "./Dictionary.css";
import Results from "./Results.js";
import Photos from "./Photos.js";

export default function Dictionary() {
  let [keyword, setKeyword] = useState("mountain");
  let [results, setResults] = useState(null);
  let [loaded, setLoaded] = useState(false);
  let [photos, setPhotos] = useState(null);

  function defaultSearch() {
    let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en/${keyword}`;

    axios.get(apiUrl).then(handleDictionaryResponse);

    let pexelsApiKey =
      "563492ad6f9170000100000176249385343b473d8b050c18daf1937a";
    let pexelsApiUrl = `https://api.pexels.com/v1/search?query=${keyword}&per_page=6`;
    let headers = { Authorization: `Bearer ${pexelsApiKey}` };

    axios
      .get(pexelsApiUrl, {
        headers: headers,
      })
      .then(handlePexelsResponse);
  }

  function handleSubmit(event) {
    event.preventDefault();
    defaultSearch();
  }

  function handleDictionaryResponse(response) {
    setResults(response.data[0]);
  }

  function handlePexelsResponse(response) {
    setPhotos(response.data.photos);
  }

  function handleKeywordChange(event) {
    setKeyword(event.target.value);
  }

  function load() {
    setLoaded(true);
    defaultSearch();
  }

  if (loaded) {
    return (
      <div className="Dictionary">
        <section>
          <div className="Intro">What word do you want to search for?</div>
          <form onSubmit={handleSubmit}>
            <input
              type="search"
              placeholder="Search for..."
              autoFocus="on"
              onChange={handleKeywordChange}
            />
          </form>
        </section>
        <Results results={results} />
        <Photos photos={photos} />
        <div className="coder">
          This project was coded by{" "}
          <a
            href="https://www.linkedin.com/in/josefina-valtier-031bb2110/"
            target="_blank"
            rel="noreferrer"
          >
            Josefina Valtier
          </a>{" "}
          and is{" "}
          <a
            href="https://github.com/josevaltier/dictionary-project"
            target="_blank"
            rel="noreferrer"
          >
            open-sourced on Github
          </a>
        </div>
      </div>
    );
  } else {
    load();
  }
}
